import { IEmbedContext } from "../interfaces/launcher";

/**
 * Collects what we can learn about the page embedding us (the casino).
 *
 * Cross-origin iframes cannot read the parent's full URL, so this is best-effort:
 * - ancestorOrigins gives ancestor origins only, and is Chromium/Safari only (absent on Firefox)
 * - document.referrer is usually truncated to the origin by the default referrer policy,
 *   and is empty entirely under `no-referrer`
 *
 * Every read is guarded: accessing window.top across origins can throw.
 */
export const getEmbedContext = (): IEmbedContext => {
  return {
    ancestorOrigins: getAncestorOrigins(),
    referrer: getReferrer(),
    isFramed: getIsFramed(),
    exitUrl: getExitUrl(),
  };
};

const getAncestorOrigins = (): string[] => {
  try {
    const origins = (window.location as any).ancestorOrigins;
    return origins ? Array.from<string>(origins) : [];
  } catch {
    return [];
  }
};

const getReferrer = (): string => {
  try {
    return document.referrer || "";
  } catch {
    return "";
  }
};

const getIsFramed = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    // A cross-origin parent makes window.top throw, which itself means we are framed.
    return true;
  }
};

const getExitUrl = (): string => {
  try {
    return new URL(window.location.href).searchParams.get("exitUrl") || "";
  } catch {
    return "";
  }
};
